// // import Icons
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "remixicon/fonts/remixicon.css";

// // import Bootstrap
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";

// import "./App.css";
// import Header from "./components/Header";
// import SideBar from "./components/SideBar";

// function App() {
//   return (
//     <>
//       <Header />;
//       <SideBar />
//     </>
//   );
// }

// export default App;

// import "bootstrap-icons/font/bootstrap-icons.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import "remixicon/fonts/remixicon.css";

// // import Bootstrap
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";

// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { AuthProvider } from "./context/AuthContext";
// // import Sidebar from "./components/Sidebar";
// import Dashboard from "./pages/dashboard/Dashboard";
// import Login from "./pages/Login/Login";
// import "./App.css";
// import Header from "./components/Header";
// import SideBar from "./components/SideBar";
// import PrivateRoute from "./components/PrivateRoute";
// import Main from "./components/Main";
// import Footer from "./components/Footer";
// // import BackToTop from "./components/BackToTop";

// function App() {
//     return (
//         <Router>
//             <AuthProvider>
//                 <Routes>
//                     {/* 🔹 Redirect `/` to `/login` by default */}
//                     <Route path="/" element={<Navigate to="/login" />} />
                    
//                     <Route path="/login" element={<Login />} />
//                     <Route 
//                         path="/dashboard" 
//                         element={<PrivateRoute> <Header />;
//                                          <SideBar />
//                                          <Main/>
//                                          <Footer/>
//                                          {/* <BackToTop/> */}
//                                 </PrivateRoute>} 
//                     />
//                 </Routes>
//             </AuthProvider>
//         </Router>
//     );
// }

// export default App;

import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "remixicon/fonts/remixicon.css";

// import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AppRoutes from "./routes/AppRoutes";
import "./App.css"; // Keep your styles

function App() {
    return (
        <Router>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </Router>
    );
}

export default App;




